<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList" :editLead="selectedLead"></Edit>
    <v-card :loading="loading" outlined>
      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title>{{ count }} Application</v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-btn class="mr-2" @click="print" outlined rounded raised small>
          <v-icon small>print</v-icon> Print
        </v-btn>
        <v-btn v-if="checkRightStatus(13)" @click="add" outlined rounded raised small>
          <v-icon small>add</v-icon> New
        </v-btn>
      </v-toolbar>

      <v-card-title>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
              hide-details clearable></v-text-field>
          </v-col>
          <v-col>
            <ClassesDropbox @classSelected="classSelected" :ClassName="ClassName"/>
          </v-col>
          <v-col cols="12" md="4">
            <v-select @change="getList()" rounded dense outlined v-model="selectedStatus" :items="leadStatus"
              label="Status" multiple>
              <template v-slot:selection="{ item, index }">
                <v-chip small v-if="index < 2">
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text text-caption">
                  (+{{ selectedStatus.length - 2 }} others)
                </span>
              </template>
            </v-select>



            <!-- <v-select dense outlined @change="getList()" rounded :items="leadStatus" v-model="selectedStatus"
              label="Status" item-text="name" hide-details return-object></v-select> -->
          </v-col>


        </v-row>
      </v-card-title>
      <v-data-table :server-items-length="count" :footer-props="{ 'items-per-page-options': [10, 25, 35, 50]}"
        class="pageHeight" :headers="headers" :items="Leads" :search="search" :loading="loading"
        :options.sync="options">
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left" @click="profile(item)">
              <div class="font-weight-bold">#{{ item.localId }}</div>
            </td>
            <td class="text-left" @click="profile(item)">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ item.createdAt | moment("from", "now") }}</span>
                </template>
                <span> {{ item.createdAt | moment("L LT") }}</span>
              </v-tooltip>

            </td>
            <td class="text-left" @click="profile(item)">
              <v-avatar v-if="item.gender === 'female'" size="20" color="pink" class="mr-1 text-uppercase">
                <span class="white--text">{{ item.gender.charAt(0) }}</span>
              </v-avatar>
              <v-avatar v-else size="20" color="blue" class="mr-1 text-uppercase">
                <span class="white--text">{{ item.gender.charAt(0) }}</span>
              </v-avatar>
              <span v-html="$options.filters.highlight(item.fullName, search)">{{ item.fullName }}</span>
            </td>
            <td @click="profile(item)">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ getAge(item.dob) }}</span>
                </template>
                <span> {{ item.dob | moment("L") }}</span>
              </v-tooltip>
            </td>
            <td class="text-left" @click="profile(item)">
              <div v-if="item.Lead.isChild"
                v-html="$options.filters.highlight(item.Lead.fatherName, search)">
                {{ item.Lead.fatherName }}
              </div>
              <div v-else>N/A</div>
            </td>
            <td class="text-left" @click="profile(item)">
              <div v-html="$options.filters.highlight(item.Lead.fatherPhoneNumber, search)">
                {{item.Lead.fatherPhoneNumber }}
              </div>
              <div v-if="item.Lead.motherPhoneNumber"
                v-html="$options.filters.highlight(item.Lead.motherPhoneNumber, search)">
                {{item.Lead.motherPhoneNumber }}
              </div>
            </td>
            <td class="text-left" @click="profile(item)" v-if="item.Class"
              v-html="$options.filters.highlight(item.Class.name, search)">
              {{ item.Class.name }}
            </td>

            <td class="text-left" @click="profile(item)">
              <v-chip class="text-capitalize" small :color="statusColor(item.status)"
                v-html="$options.filters.highlight(item.status, search)" dark rounded>{{
                item.status }}</v-chip>
            </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item v-if="checkRightStatus(15)" @click="editLead(item.Lead)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item v-if="checkRightStatus(45)" @click="deleteLead(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template v-slot:body.append>
          <tr>
            <td class="text-right font-weight-bold">
              Total Applications:
            </td>

            <td class="font-weight-bold">
              {{ count }}
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-model="showPdf" max-width="700">
      <v-card style="height: 800px">
        <v-toolbar class="elevation-0">
          <v-toolbar-title class="subheading">Application</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop.prevent="showPdf = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout fill-height column>
          <embed id="embedPDF" :src="pdf" type="application/pdf" height="100%" width="100%" />
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import leadService from "../service";
import ClassesDropbox from "@/modules/Classes/components/Dropbox.vue";
import { mapGetters } from "vuex";
import _ from 'lodash';

const Create = () => import("./Create");
const Edit = () => import("./Edit");
import pdfMake from 'pdfmake/build/pdfmake.min';
import { pdfMake as pdfFonts } from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.vfs;

export default {
  name: "lead-list",
  data() {
    return {
      leadStatus: ["pending", "Open", "Contacted", "Waiting", "Closed", "Convert", "Ready to join"],
      createDialog: false,
      editDialog: false,
      count: 0,
      selectedLead: null,
      headers: [
        {
          text: "Local ID",
          align: "left",
          value: "localId",
          sortable: true,
        },
        {
          text: "Created At",
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Student Name",
          align: "left",
          value: "firstName",
          sortable: true,
        },
        {
          text: "Age",
          align: "left",
          value: "age",
          sortable: false,
        },
        {
          text: "Father Name",
          value: "Lead.fatherName",
          sortable: false,
        },
        {
          text: "Phone Number",
          align: "left",
          value: "Lead.fatherPhoneNumber",
          sortable: false,
        },
        {
          text: "Class",
          align: "left",
          value: "Class.name",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      Leads: [],
      selectedStatus: ["pending", "Open", "Waiting", "Contacted", "Ready to join"],
      search: '',
      loading: true,
      selectedClasses: [],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [false]
      },
      doc: {
        content: []
      },
      ClassName: null,
      pdf: null,
      showPdf: false,
    };
  },
  watch: {
    search: {
      handler: _.debounce(function () {
        if (!this.loading) {
          this.getList();
        }
      }, 500),
    },
    options: {
      handler() {
        if(!this.loading)
          this.getList();
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.query) {
      if(this.$route.query.search)
        this.search = this.$route.query.search
      if(this.$route.query.ClassId)
      this.selectedClasses = [this.$route.query.ClassId]
    if(this.$route.query.ClassName)
      this.ClassName = this.$route.query.ClassName
    }
    this.getList();
    document.title = "taleem - Application";
  },
  filters: {
    highlight(words, query) {
      if (query) {
        var check = new RegExp(query.toLowerCase(), "ig");
        if (words) {
          return words.toString().replace(check, function (matchedText) {
            return '<span class="highlight">' + matchedText + "</span>";
          });
        } else {
          return words;
        }
      } else {
        return words;
      }
    },
  },
  components: {
    Create,
    Edit,
    ClassesDropbox
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus", 'currentBusiness']),
  },
  methods: {
    classSelected(val) {
      this.selectedClasses = val
      this.getList()
    },
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    statusColor(status) {
      let color = 'green'
      switch (status) {
        case 'Open':
          color = '#1976D2'
          break;
        case 'Contacted':
          color = '#6A1B9A'
          break;
        case 'Closed':
          color = 'red'
          break;
        case 'Waiting':
          color = '#AED581'
          break;
        case 'Ready to join':
          color = '#00BFA5'
          break;
        default:
          color = 'green'
      }

      return color
    },
    profile(row) {
      this.$router.push({ path: `/applications/${row.Lead.id}/profile` });
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let offset = 0
      if (itemsPerPage > 0 && page) {
        offset = itemsPerPage * page - itemsPerPage;
      }
      let where = {
        status: this.selectedStatus,
        filteredClasses: this.selectedClasses,
        limit: itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };
      if (this.search && this.search.length >= 1) {
        where.search = this.search
      } else {
        where.offset = offset
      }
      return leadService
        .getAllStudent(where)
        .then((response) => {
          this.loading = false;
          console.log("Leads", response);
          this.Leads = response.data;
          this.count = response.count;
          this.itemsPerPage = this.Leads.length
          return response;
        });
    },
    editLead(lead) {
      this.selectedLead = lead;
      this.editDialog = !this.editDialog;
    },
    deleteLead(lead) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          leadService.delete(lead.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Lead has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
    async print() {
      this.doc.content = []
      if (this.currentBusiness && this.currentBusiness.imageUrl) {
        try {
          const toDataURL = (url) =>
            fetch(url, { mode: 'cors' })
              .then((response) => response.blob())
              .then(
                (blob) =>
                  new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                  }),
              );

          const base64 = await toDataURL(this.currentBusiness.imageUrl).then(
            (dataUrl) => dataUrl,
          );

          this.doc.content.push({
            image: base64,
            width: 200,
            height: 100,
            alignment: 'center',
          });
        } catch (error) {
          console.log('image through error');
        }
      }
      this.doc.content.push({
        text: this.currentBusiness.name,
        alignment: 'center',
        fontSize: 15,
        bold: true,
      });
      this.doc.content.push({
        text: `${this.currentBusiness.name} ${this.currentBusiness.address} ${this.currentBusiness.city}, ${this.currentBusiness.state} ${this.currentBusiness.zip}`,
        alignment: 'center',
        fontSize: 11,
      });
      this.doc.content.push({
        text: this.currentBusiness.phoneNumber,
        alignment: 'center',
        fontSize: 11,
      });
      this.doc.content.push({
        text: this.currentBusiness.email,
        alignment: 'center',
        fontSize: 11,
      });
      this.doc.content.push({
        text: this.currentBusiness.website,
        alignment: 'center',
        fontSize: 11,
      });
      this.doc.content.push({
        columns: [
          { text: "Application", alignment: 'left', fontSize: 18, bold: true, margin: [2, 2] },
          { text: "Total Applications: " + this.count, alignment: 'right', fontSize: 16, bold: true, margin: [2, 2] }
        ]
      })
      let applications = [[{ text: 'CreatedAt', bold: true }, { text: 'StudentName', bold: true }, { text: 'FatherName', bold: true }, { text: 'PhoneNumber', bold: true }, { text: 'Class', bold: true }, { text: 'Status', bold: true }]]
      this.Leads.map(lead => {
        applications.push([{ text: `${this.$moment(lead.createdAt).format('L LT')}` },
        { text: `${lead.fullName}(${this.getAge(lead.dob)})` }, { text: lead.Lead.fatherName },
        { text: lead.Lead.motherPhoneNumber ? `${lead.Lead.fatherPhoneNumber}\n${lead.Lead.motherPhoneNumber}` : lead.Lead.fatherPhoneNumber, alignment: 'center' },
        { text: lead.Class.name }, { text: lead.status, bold: true }
        ])
      })
      let borderStyle = {
        hLineWidth: function (i, node) {
          if (i === 0 || i === 1 || i === node.table.body.length - 1 || i === node.table.body.length) {
            return 2;
          }
          return 1;
        },
        vLineWidth: function (i, node) {
          if (i === 0 || i === node.table.widths.length) {
            return 2;
          }
          return 1;
        },
        hLineColor: function () {
          return 'black';
        },
        vLineColor: function () {
          return 'black';
        }
      };
      this.doc.content.push({
        table: {
          margin: [0, 6, 0, 0],
          widths: ['auto', '*', '*', '*', '*', 'auto'],
          body: applications
        },
        layout: borderStyle
      })
      pdfMake.createPdf(this.doc).getDataUrl(data => {
        this.pdf = data;
      });
      this.showPdf = true
    },
  },
};
</script>
